module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid10.9479614b.png";